/* eslint-disable max-len */
export default {
  ACTIONS: {
    FINISH: 'Fine',
    NEXT: 'Continua'
  },
  ERRORS: {
    GREATER_THAN: 'Non può essere maggiore di {max}.',
    INVALID_PROZIS_POINTS:
      'Ops, i ProzisPoints che vuoi condividere con il corriere non sono più disponibili. Si prega di riprovare.',
    LESS_THAN: 'Non può essere minore di {min}.',
    MAX_CHARACTERS: 'La descrizione può avere massimo {max} caratteri.',
    REQUIRED: 'Campo obbligatorio.',
    VALIDATING_CODE: 'Non è stato possibile convalidare il codice {code}.'
  },
  LABELS: {
    COMMENT: 'Commento',
    COURIER: 'corriere',
    ERROR: 'Errore',
    EXPERIENCE_EVALUATION: 'VALUTA L\'ESPERIENZA DI CONSEGNA',
    MORE_TO_SAY: 'IMPROVE OURSELVES',
    OTHER: 'Altro',
    PROZIS_NOW: 'PROZIS NOW'
  },
  SENTENCES: {
    AMAZED:
      '😁 Siamo molto contenti che sia andato tutto bene. Cosa ti è piaciuto di più?',
    ANSWERED_SURVEY:
      'Abbiamo già ricevuto il tuo feedback relativo alla consegna dell\'ordine {code}. \n\rAspettiamo la tua opinione sulle tue prossime esperienze. 👍',
    ENTITY: 'Cosa ne pensi di {entity}?',
    POINTS: 'Hai {points} ProzisPoints.',
    SATISFIED:
      '😁 Siamo contenti che sia andato tutto bene. Cosa possiamo migliorare?',
    SHARE_POINTS:
      'Vorresti lasciare una mancia a {entity}? Puoi condividere i tuoi ProzisPoints. 🙂',
    THANKS: '😀 Grazie, {name}.',
    UNHAPPY:
      '😔 Ci dispiace sapere che la consegna non sia andata come previsto. Cosa è andato storto?'
  }
};
